export default __webpack_public_path__ + "static/media/art-5-main-lg.d030f490.jpg";